export default __webpack_public_path__ + "static/media/large.8205097c.jpg";